module.exports = "/assets/c7d74a2ea59507d300ad0c5a7b5a3754.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RI.png
// module id = 2910
// module chunks = 0